export const BASE = import.meta.env.BASE_URL;